import {
	Box,
	Card,
	CardContent,
	CardHeader,
	CircularProgress,
	IconButton,
	Link,
	Tooltip,
	Typography,
} from '@mui/material';
import { COLORS } from '../../services/constants/colors';
import { OpenInNew, ScreenshotMonitor } from '@mui/icons-material';
import { useCallback, useRef } from 'react';
import { EasScreenshotFrame, EasScreenshotFrameRef } from '../EasScreenshotFrame';
import { TBoxLink } from '../../components/EMManagement/EMManagementId/emBoxesStructure';

export const EasCard = ({
	id,
	link,
	children,
	title,
	action,
	loading,
}: {
	id: string;
	link?: TBoxLink;
	children: React.ReactNode;
	title: string;
	action?: React.ReactNode;
	loading?: boolean;
}) => {
	const frameRef = useRef<EasScreenshotFrameRef>(null);

	const onShot = useCallback(() => {
		frameRef.current?.takeScreenshot();
	}, []);

	return (
		<EasScreenshotFrame ref={frameRef} id={id} title={title}>
			<Card sx={{ mb: 1, '&': { borderRadius: '12px' }, height: '100%', width: '100%' }}>
				<CardHeader
					sx={{
						backgroundColor: COLORS.BACKGROUND_SECONDARY,
						p: 0.5,
						m: 0,
					}}
					title={
						<Box
							sx={{
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'space-between',
								alignItems: 'center',
							}}
						>
							<Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 0.5 }}>
								<Typography
									variant="h6"
									component="div"
									sx={{
										fontSize: '1rem',
										color: 'primary.main',
										fontWeight: 'bold',
										p: 0,
										m: 0,
										ml: 0.5,
									}}
								>
									{title}
								</Typography>
								{link && (
									<Link href={link.url} target="_blank" sx={{ textDecoration: 'none' }}>
										<Typography
											variant="h6"
											component="div"
											sx={{
												fontSize: '0.8rem',
												color: COLORS.PRIMARY,
												fontWeight: 'bold',
												p: 0,
												m: 0,
												ml: 0.5,
											}}
										>
											{link.label}
											<OpenInNew sx={{ fontSize: '0.7rem', p: 0, m: 0, ml: 0.5 }} />
										</Typography>
									</Link>
								)}
							</Box>
							<Box
								sx={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									gap: 0.5,
									p: 0,
									m: 0,
								}}
							>
								{loading && <CircularProgress size={20} />}
								{action}
								<Tooltip title="Generate Screenshot">
									<IconButton size="small" color="primary" onClick={onShot} sx={{ p: 0, m: 0 }}>
										<ScreenshotMonitor sx={{ fontSize: '1.5rem', p: 0, m: 0 }} />
									</IconButton>
								</Tooltip>
							</Box>
						</Box>
					}
				/>
				<CardContent sx={{ padding: '10px!important' }}>{children}</CardContent>
			</Card>
		</EasScreenshotFrame>
	);
};
